__turbopack_context__.v({
  "arrow": "DhMbzq_arrow",
  "caption": "DhMbzq_caption",
  "captions": "DhMbzq_captions",
  "defs": "DhMbzq_defs",
  "frame": "DhMbzq_frame",
  "next": "DhMbzq_next",
  "overlay": "DhMbzq_overlay",
  "overlayArt": "DhMbzq_overlayArt",
  "overlays": "DhMbzq_overlays",
  "photo": "DhMbzq_photo",
  "prev": "DhMbzq_prev",
  "root": "DhMbzq_root",
  "row": "DhMbzq_row",
  "slot": "DhMbzq_slot",
  "stage": "DhMbzq_stage",
});
